export default "__VITE_ASSET__UNaExAXL__"